import React from 'react'
export default function ChatBox({ is_typing }) {
  return <div>{is_typing ? <Typing /> : null}</div>
}

function Typing() {
  return <div className='typing'>
    <div className='typing_dot' />
    <div className='typing_dot' />
    <div className='typing_dot' />
  </div>
}